/* src/app/shared/common-ui/lib/date-panel/date-panel.component.less */
.wrapper-date-panel {
  display: flex;
  flex-direction: column;
  padding: 2.4rem;
  background: var(--color-default-input-background);
  -webkit-user-select: none;
  user-select: none;
}
.wrapper-date-panel .dropdownItem {
  height: 3.6rem;
}
.wrapper-date-panel .datePreset {
  margin-bottom: 2.4rem;
}
.wrapper-date-panel .datePreset::ng-deep .action {
  border-color: var(--color-default-text);
}
.wrapper-date-panel.small {
  height: 32.4rem;
  width: 27.6rem;
}
.wrapper-date-panel.small.hasDatePreset {
  height: 38.8rem;
}
.wrapper-date-panel.small .navHeader {
  margin: 0 0.7rem;
}
.wrapper-date-panel.small .content .weekdays {
  font-size: 1.2rem;
}
.wrapper-date-panel.small .content .days .date {
  height: 3rem;
  font-size: 1.2rem;
}
.wrapper-date-panel.small .content .days .date.notSelectable.isFirstDayOfWeek,
.wrapper-date-panel.small .content .days .date.isBetween.isFirstDayOfWeek,
.wrapper-date-panel.small .content .days .date.selected.isFirstDayOfWeek {
  border-radius: 1.5rem 0 0 1.5rem;
}
.wrapper-date-panel.small .content .days .date.notSelectable.isLastDayOfWeek,
.wrapper-date-panel.small .content .days .date.isBetween.isLastDayOfWeek,
.wrapper-date-panel.small .content .days .date.selected.isLastDayOfWeek {
  border-radius: 0 1.5rem 1.5rem 0;
}
.wrapper-date-panel.small .content .days .date.notSelectable.isFirstDayOfWeek.isLastDayOfWeek,
.wrapper-date-panel.small .content .days .date.isBetween.isFirstDayOfWeek.isLastDayOfWeek,
.wrapper-date-panel.small .content .days .date.selected.isFirstDayOfWeek.isLastDayOfWeek {
  border-radius: 1.5rem;
}
.wrapper-date-panel.small .content .days .selection {
  height: 3rem;
  width: 3rem;
}
.wrapper-date-panel.medium {
  height: 36rem;
  width: 42rem;
}
.wrapper-date-panel.medium.hasDatePreset {
  height: 42.4rem;
}
.wrapper-date-panel.medium .navHeader {
  margin: 0 1.5rem;
}
.wrapper-date-panel.medium .content .days .date {
  height: 3.5rem;
}
.wrapper-date-panel.medium .content .days .date.notSelectable.isFirstDayOfWeek,
.wrapper-date-panel.medium .content .days .date.isBetween.isFirstDayOfWeek,
.wrapper-date-panel.medium .content .days .date.selected.isFirstDayOfWeek {
  border-radius: 1.75rem 0 0 1.75rem;
}
.wrapper-date-panel.medium .content .days .date.notSelectable.isLastDayOfWeek,
.wrapper-date-panel.medium .content .days .date.isBetween.isLastDayOfWeek,
.wrapper-date-panel.medium .content .days .date.selected.isLastDayOfWeek {
  border-radius: 0 1.75rem 1.75rem 0;
}
.wrapper-date-panel.medium .content .days .date.notSelectable.isFirstDayOfWeek.isLastDayOfWeek,
.wrapper-date-panel.medium .content .days .date.isBetween.isFirstDayOfWeek.isLastDayOfWeek,
.wrapper-date-panel.medium .content .days .date.selected.isFirstDayOfWeek.isLastDayOfWeek {
  border-radius: 1.75rem;
}
.wrapper-date-panel .months {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  max-height: 31.4rem;
  font-size: 1.8rem;
  font-weight: 600;
  line-height: 2.2rem;
  text-transform: capitalize;
}
.wrapper-date-panel .months .month {
  display: flex;
  justify-content: center;
  padding: 1.5rem;
  color: var(--color-default-button);
  cursor: pointer;
}
.wrapper-date-panel .months .month.active {
  color: initial;
}
.wrapper-date-panel .months .month:hover {
  color: var(--color-default-button-hover);
}
.wrapper-date-panel .months.small {
  max-height: 31rem;
}
.wrapper-date-panel .months.small .month {
  padding: 1.2rem;
}
.wrapper-date-panel .navHeader {
  display: flex;
  align-items: center;
  font-size: 1.8rem;
  font-weight: 600;
  line-height: 2.2rem;
  color: var(--color-default-button);
}
.wrapper-date-panel .navHeader .month {
  margin-right: 1.2rem;
  font-size: 1.8rem;
  font-weight: 600;
  line-height: 2.2rem;
  text-transform: capitalize;
  cursor: pointer;
}
.wrapper-date-panel .navHeader .month:hover {
  color: var(--color-default-button-hover);
}
.wrapper-date-panel .navHeader .year {
  font-size: 1.8rem;
  font-weight: 600;
  line-height: 2.2rem;
  cursor: pointer;
}
.wrapper-date-panel .navHeader .year:hover {
  color: var(--color-default-button-hover);
}
.wrapper-date-panel .navHeader .navMonth {
  flex: 1;
  display: flex;
  justify-content: flex-end;
}
.wrapper-date-panel .navHeader .navMonth .icon {
  height: 2.4rem;
  width: 2.4rem;
  background: var(--color-default-button);
  cursor: pointer;
}
.wrapper-date-panel .navHeader .navMonth .icon:hover {
  background: var(--color-default-button-hover);
}
.wrapper-date-panel .navHeader .navMonth .icon.prev {
  mask: url("data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%3F%3E%0A%3Csvg%20width%3D%2220px%22%20height%3D%2220px%22%20viewBox%3D%220%200%2036%2036%22%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%0A%20%20%20%20%3C!--%20Generator%3A%20Sketch%2063.1%20(92452)%20-%20https%3A%2F%2Fsketch.com%20--%3E%0A%20%20%20%20%3Ctitle%3E2%20Icons%20%2F%20Chevron%20Left%3C%2Ftitle%3E%0A%20%20%20%20%3Cdesc%3ECreated%20with%20Sketch.%3C%2Fdesc%3E%0A%20%20%20%20%3Cg%20id%3D%222-Icons-%2F-Chevron-Left%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%3E%0A%20%20%20%20%20%20%20%20%3Crect%20id%3D%22Rectangle%22%20x%3D%220%22%20y%3D%220%22%20width%3D%2236%22%20height%3D%2236%22%3E%3C%2Frect%3E%0A%20%20%20%20%20%20%20%20%3Cpolygon%20id%3D%22Path%22%20fill%3D%22%23005EB8%22%20points%3D%2210.0309597%2018%2024.0406774%206.24445104%2025.9690403%208.54258437%2014.6981312%2018%2025.9690403%2027.4574156%2024.0406774%2029.755549%22%3E%3C%2Fpolygon%3E%0A%20%20%20%20%3C%2Fg%3E%0A%3C%2Fsvg%3E") no-repeat center;
  mask-size: 2.4rem 2.4rem;
}
.wrapper-date-panel .navHeader .navMonth .icon.next {
  margin-left: 1.2rem;
  mask: url("data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%3F%3E%0A%3Csvg%20width%3D%2218px%22%20height%3D%2218px%22%20viewBox%3D%220%200%2018%2018%22%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%0A%20%20%20%20%3C!--%20Generator%3A%20sketchtool%2061.2%20(101010)%20-%20https%3A%2F%2Fsketch.com%20--%3E%0A%20%20%20%20%3Ctitle%3E95AAE27D-CDA3-47B2-B384-06CB588167C7%3C%2Ftitle%3E%0A%20%20%20%20%3Cdesc%3ECreated%20with%20sketchtool.%3C%2Fdesc%3E%0A%20%20%20%20%3Cg%20id%3D%22Asset-Artboard-Page%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%3E%0A%20%20%20%20%20%20%20%20%3Cg%20id%3D%222-Icons-%2F-Arrow-Left-Copy-2-Icons-%2F-Arrow-Left%22%20transform%3D%22translate(9.000000%2C%2010.000000)%20rotate(-180.000000)%20translate(-9.000000%2C%20-10.000000)%20translate(0.000000%2C%201.000000)%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Crect%20id%3D%22Rectangle%22%20x%3D%220%22%20y%3D%220%22%20width%3D%2218%22%20height%3D%2218%22%3E%3C%2Frect%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cpolygon%20id%3D%22Path%22%20fill%3D%22%23FFFFFF%22%20points%3D%225.01548004%209.00000024%2012.020339%203.12222552%2012.9845204%204.27129223%207.34906582%209.00000024%2012.9845204%2013.7287082%2012.020339%2014.877775%22%3E%3C%2Fpolygon%3E%0A%20%20%20%20%20%20%20%20%3C%2Fg%3E%0A%20%20%20%20%3C%2Fg%3E%0A%3C%2Fsvg%3E") no-repeat center;
  mask-size: 2.4rem 2.4rem;
}
.wrapper-date-panel .navHeader .navMonth .icon.next.withToday {
  margin: initial;
}
.wrapper-date-panel .navHeader .navMonth .icon.today {
  margin: 0 1.2rem;
  mask: url("data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%3F%3E%0A%3Csvg%20width%3D%2236px%22%20height%3D%2236px%22%20viewBox%3D%220%200%2036%2036%22%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%0A%20%20%20%20%3C!--%20Generator%3A%20Sketch%2063.1%20(92452)%20-%20https%3A%2F%2Fsketch.com%20--%3E%0A%20%20%20%20%3Ctitle%3E2%20Icons%20%2F%20Calendar%20%2F%20Current%20Day%3C%2Ftitle%3E%0A%20%20%20%20%3Cdesc%3ECreated%20with%20Sketch.%3C%2Fdesc%3E%0A%20%20%20%20%3Cg%20id%3D%222-Icons-%2F-Calendar-%2F-Current-Day%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%3E%0A%20%20%20%20%20%20%20%20%3Crect%20id%3D%22Rectangle%22%20x%3D%220%22%20y%3D%220%22%20width%3D%2236%22%20height%3D%2236%22%3E%3C%2Frect%3E%0A%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M12%2C4%20L12%2C6.999%20L24%2C7%20L24%2C4%20L27%2C4%20L27%2C7%20L30%2C7%20C31.5976809%2C7%2032.9036609%2C8.24891996%2032.9949073%2C9.82372721%20L33%2C10%20L33%2C30%20C33%2C31.6568542%2031.6568542%2C33%2030%2C33%20L6%2C33%20C4.34314575%2C33%203%2C31.6568542%203%2C30%20L3%2C10%20C3%2C8.34314575%204.34314575%2C7%206%2C7%20L9%2C6.999%20L9%2C4%20L12%2C4%20Z%20M12%2C9.998%20L12%2C13%20L9%2C13%20L9%2C10%20L6%2C10%20L6%2C30%20L30%2C30%20L30%2C10%20L27%2C10%20L27%2C13%20L24%2C13%20L24%2C10%20L12%2C9.998%20Z%20M23.657609%2C14.7591814%20L25.7789293%2C16.8805018%20L15.8794344%2C26.7799967%20L13.7581141%2C24.6586763%20L13.759433%2C24.6571669%20L10.2231619%2C21.1195417%20L12.3444822%2C18.9982214%20L15.8807533%2C22.5358465%20L23.657609%2C14.7591814%20Z%22%20id%3D%22Shape%22%20fill%3D%22%23005EB8%22%3E%3C%2Fpath%3E%0A%20%20%20%20%3C%2Fg%3E%0A%3C%2Fsvg%3E") no-repeat center;
  mask-size: 2.4rem 2.4rem;
}
.wrapper-date-panel .navYears {
  flex: 1;
  display: flex;
  justify-content: center;
  margin-bottom: 1rem;
}
.wrapper-date-panel .navYears .icon {
  height: 2.4rem;
  width: 2.4rem;
  background: var(--color-default-button);
  cursor: pointer;
}
.wrapper-date-panel .navYears .icon:hover {
  background: var(--color-default-button-hover);
}
.wrapper-date-panel .navYears .icon.prev {
  mask: url("data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%3F%3E%0A%3Csvg%20width%3D%2220px%22%20height%3D%2220px%22%20viewBox%3D%220%200%2036%2036%22%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%0A%20%20%20%20%3C!--%20Generator%3A%20Sketch%2063.1%20(92452)%20-%20https%3A%2F%2Fsketch.com%20--%3E%0A%20%20%20%20%3Ctitle%3E2%20Icons%20%2F%20Chevron%20Left%3C%2Ftitle%3E%0A%20%20%20%20%3Cdesc%3ECreated%20with%20Sketch.%3C%2Fdesc%3E%0A%20%20%20%20%3Cg%20id%3D%222-Icons-%2F-Chevron-Left%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%3E%0A%20%20%20%20%20%20%20%20%3Crect%20id%3D%22Rectangle%22%20x%3D%220%22%20y%3D%220%22%20width%3D%2236%22%20height%3D%2236%22%3E%3C%2Frect%3E%0A%20%20%20%20%20%20%20%20%3Cpolygon%20id%3D%22Path%22%20fill%3D%22%23005EB8%22%20points%3D%2210.0309597%2018%2024.0406774%206.24445104%2025.9690403%208.54258437%2014.6981312%2018%2025.9690403%2027.4574156%2024.0406774%2029.755549%22%3E%3C%2Fpolygon%3E%0A%20%20%20%20%3C%2Fg%3E%0A%3C%2Fsvg%3E") no-repeat center;
  mask-size: 2.4rem 2.4rem;
}
.wrapper-date-panel .navYears .icon.next {
  margin-left: 1.2rem;
  mask: url("data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%3F%3E%0A%3Csvg%20width%3D%2218px%22%20height%3D%2218px%22%20viewBox%3D%220%200%2018%2018%22%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%0A%20%20%20%20%3C!--%20Generator%3A%20sketchtool%2061.2%20(101010)%20-%20https%3A%2F%2Fsketch.com%20--%3E%0A%20%20%20%20%3Ctitle%3E95AAE27D-CDA3-47B2-B384-06CB588167C7%3C%2Ftitle%3E%0A%20%20%20%20%3Cdesc%3ECreated%20with%20sketchtool.%3C%2Fdesc%3E%0A%20%20%20%20%3Cg%20id%3D%22Asset-Artboard-Page%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%3E%0A%20%20%20%20%20%20%20%20%3Cg%20id%3D%222-Icons-%2F-Arrow-Left-Copy-2-Icons-%2F-Arrow-Left%22%20transform%3D%22translate(9.000000%2C%2010.000000)%20rotate(-180.000000)%20translate(-9.000000%2C%20-10.000000)%20translate(0.000000%2C%201.000000)%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Crect%20id%3D%22Rectangle%22%20x%3D%220%22%20y%3D%220%22%20width%3D%2218%22%20height%3D%2218%22%3E%3C%2Frect%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cpolygon%20id%3D%22Path%22%20fill%3D%22%23FFFFFF%22%20points%3D%225.01548004%209.00000024%2012.020339%203.12222552%2012.9845204%204.27129223%207.34906582%209.00000024%2012.9845204%2013.7287082%2012.020339%2014.877775%22%3E%3C%2Fpolygon%3E%0A%20%20%20%20%20%20%20%20%3C%2Fg%3E%0A%20%20%20%20%3C%2Fg%3E%0A%3C%2Fsvg%3E") no-repeat center;
  mask-size: 2.4rem 2.4rem;
}
.wrapper-date-panel .navYears .icon.next.withToday {
  margin: initial;
}
.wrapper-date-panel .navYears .icon.today {
  margin: 0 1.2rem;
  mask: url("data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%3F%3E%0A%3Csvg%20width%3D%2236px%22%20height%3D%2236px%22%20viewBox%3D%220%200%2036%2036%22%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%0A%20%20%20%20%3C!--%20Generator%3A%20Sketch%2063.1%20(92452)%20-%20https%3A%2F%2Fsketch.com%20--%3E%0A%20%20%20%20%3Ctitle%3E2%20Icons%20%2F%20Calendar%20%2F%20Current%20Day%3C%2Ftitle%3E%0A%20%20%20%20%3Cdesc%3ECreated%20with%20Sketch.%3C%2Fdesc%3E%0A%20%20%20%20%3Cg%20id%3D%222-Icons-%2F-Calendar-%2F-Current-Day%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%3E%0A%20%20%20%20%20%20%20%20%3Crect%20id%3D%22Rectangle%22%20x%3D%220%22%20y%3D%220%22%20width%3D%2236%22%20height%3D%2236%22%3E%3C%2Frect%3E%0A%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M12%2C4%20L12%2C6.999%20L24%2C7%20L24%2C4%20L27%2C4%20L27%2C7%20L30%2C7%20C31.5976809%2C7%2032.9036609%2C8.24891996%2032.9949073%2C9.82372721%20L33%2C10%20L33%2C30%20C33%2C31.6568542%2031.6568542%2C33%2030%2C33%20L6%2C33%20C4.34314575%2C33%203%2C31.6568542%203%2C30%20L3%2C10%20C3%2C8.34314575%204.34314575%2C7%206%2C7%20L9%2C6.999%20L9%2C4%20L12%2C4%20Z%20M12%2C9.998%20L12%2C13%20L9%2C13%20L9%2C10%20L6%2C10%20L6%2C30%20L30%2C30%20L30%2C10%20L27%2C10%20L27%2C13%20L24%2C13%20L24%2C10%20L12%2C9.998%20Z%20M23.657609%2C14.7591814%20L25.7789293%2C16.8805018%20L15.8794344%2C26.7799967%20L13.7581141%2C24.6586763%20L13.759433%2C24.6571669%20L10.2231619%2C21.1195417%20L12.3444822%2C18.9982214%20L15.8807533%2C22.5358465%20L23.657609%2C14.7591814%20Z%22%20id%3D%22Shape%22%20fill%3D%22%23005EB8%22%3E%3C%2Fpath%3E%0A%20%20%20%20%3C%2Fg%3E%0A%3C%2Fsvg%3E") no-repeat center;
  mask-size: 2.4rem 2.4rem;
}
.wrapper-date-panel .years {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  max-height: 28.4rem;
  font-size: 1.8rem;
  font-weight: 600;
  line-height: 2.2rem;
}
.wrapper-date-panel .years .year {
  display: flex;
  justify-content: center;
  padding: 1.5rem;
  color: var(--color-default-button);
  cursor: pointer;
}
.wrapper-date-panel .years .year.active {
  color: initial;
}
.wrapper-date-panel .years .year:hover {
  color: var(--color-default-button-hover);
}
.wrapper-date-panel .content {
  margin-top: 2.4rem;
}
.wrapper-date-panel .content .weekdays {
  display: flex;
  font-size: 1.8rem;
  font-weight: 700;
}
.wrapper-date-panel .content .weekdays .day {
  flex: none;
  display: flex;
  justify-content: center;
  align-items: center;
  width: calc(100% / 7);
  text-transform: capitalize;
}
.wrapper-date-panel .content .days {
  display: flex;
  flex-wrap: wrap;
  margin-top: 1rem;
}
.wrapper-date-panel .content .days .date {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  height: 3.5rem;
  width: calc(100% / 7);
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
  font-size: 1.8rem;
  cursor: pointer;
}
.wrapper-date-panel .content .days .date.selected .daySelected {
  color: var(--color-default-static-text);
}
.wrapper-date-panel .content .days .date.fixed .daySelected {
  color: inherit;
}
.wrapper-date-panel .content .days .date.startEqualsEnd .daySelected {
  color: var(--color-default-static-text);
}
.wrapper-date-panel .content .days .isStartDate::before,
.wrapper-date-panel .content .days .isEndDate::after {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 50%;
  background-color: var(--color-default-selected-range-background);
  content: "";
  z-index: 1;
}
.wrapper-date-panel .content .days .isStartDate::before {
  right: 0;
}
.wrapper-date-panel .content .days .isEndDate::after {
  left: 0;
}
.wrapper-date-panel .content .days .isBetween {
  background-color: var(--color-default-selected-range-background);
}
.wrapper-date-panel .content .days .notSelectable {
  background: var(--color-default-background-disabled);
  cursor: unset;
}
.wrapper-date-panel .content .days .differentMonth {
  color: var(--color-default-text-disabled);
}
.wrapper-date-panel .content .days .daySelected {
  position: absolute;
  z-index: 3;
}
.wrapper-date-panel .content .days .selection {
  height: 3.5rem;
  width: 3.5rem;
  border-radius: 50%;
  z-index: 2;
}
.wrapper-date-panel .content .days .selection.today {
  border: solid 0.2rem var(--color-alternative-button-hover);
}
.wrapper-date-panel .content .days .selection.selected {
  background: var(--color-default-focus);
}
.wrapper-date-panel .content .days .selection.fixed {
  background: var(--color-default-input-background);
  border: 0.15rem solid var(--color-default-selected-background);
}
.wrapper-date-panel .content .days .selection.startEqualsEnd {
  background: var(--color-default-focus);
  border: 0;
}
/*# sourceMappingURL=date-panel.component.css.map */
